module.exports = __webpack_public_path__ + "static/antd-skeleton-content-b118c7404f469ea2e5ec978c61bacb63.gif";